<template>
  <div v-if="accountsEnabled" class="account-icon-container">
    <a href="/account">
      <icon name="account" size="24px"></icon>
    </a>
  </div>
</template>

<script>
import IconLink from '@/scripts/components/buttons/IconLink.vue'
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'NavbarAccount',
  components: { IconLink, Icon },
  data () {
    return {
      accountsEnabled: window.bvaccel && window.bvaccel.customer.accountsEnabled
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.navbar-account {}
</style>
